import { PrintLocationsSection } from "./sections/print/PrintLocationsSection";
import { useSettingsAcl } from "./lib/useSettingsAcl";
import { SettingsAccessDenied } from "./SettingsLayout";

export function DruckPage() {
  const acl = useSettingsAcl();

  if (acl.loading) return null;
  if (!acl.canAuftraege) return <SettingsAccessDenied />;

  return <PrintLocationsSection />;
}
